import { CodedError } from '../CodedError';

export class VisitorWatchlistOperationError extends CodedError {
  operation: string;

  constructor(operation: string, customMessage?: string) {
    const defaultMessage = `Visitor watchlist ${operation} operation failed`;
    const baseMessage = customMessage || defaultMessage;
    const code = `VW_${operation.toUpperCase()}`;
    const message = `${baseMessage} ${code}`;
    
    super(message);
    
    this.operation = operation;
    this.code = code;
    this.name = 'VisitorWatchlistOperationError';
  }
}
